import { configureStore } from '@reduxjs/toolkit'
import commonReducer from '../redux/commonSlice'
import userReducer from '../redux/userSlice'

export const store = configureStore({
	reducer: {
		userReducer,
		commonReducer
	},
})